import { FEATURE_TYPE_CODE } from "@/v2-backoffice-client/feature/feature.constants"

// The package editor's views: what the app can do, what the map offers,
// and the single picks the catalogs do not place.
export type ComposeView = "capabilities" | "content" | "individual"

export const COMPOSE_VIEW_LABELS: Record<ComposeView, string> = {
  capabilities: "Capabilities",
  content: "Content",
  individual: "Individual features",
}

/** The feature type every Fusion capability (gated console surface) shares. */
export const CAPABILITY_FEATURE_TYPE_CODE: number =
  FEATURE_TYPE_CODE.uiComponent

/**
 * What a row says while its change is unsaved. Said as a future, so it
 * never reads like a state ("added" looked like "already in").
 */
export const PENDING_CHANGE_LABEL = {
  added: "will be added",
  removed: "will be removed",
} as const

/** What a module's header rule covers, as the rows under it say it. */
export const WHOLE_MODULE_NOUN = "whole module"

/**
 * A row's secondary text — its kind, its reason, "also in …", a hint. One
 * flex policy for all of them: capped, shrinking three times as readily as
 * the name (which keeps a floor), and truncating rather than overflowing,
 * so a narrow card never spills a row into the column beside it.
 */
export const ROW_NOTE_CLASS =
  "min-w-0 max-w-56 shrink-[3] truncate text-[11px] text-muted-foreground"

/**
 * The one sentence about header ticks versus single ticks, shown with every
 * list that has both: the behaviour operators most often get wrong.
 */
export const RULE_VERSUS_PICKS_LEGEND =
  "Ticking a header (a module, a class, a category) includes everything in it, now and in future releases. Ticking rows one by one includes only those rows; new ones are not included."
